import { settings } from "../common/setting";

declare const $cz: any;
import { setting } from "./setting";
import { cr } from "fire-wind-water";

$cz.setup("container", (o) => {
  let isNull = true;
  let i = 0;
  if (!setting.component) {
    setting.component = {};
    cr.each(o, (d) => {
      cr.each(d, (m, j) => {
        setting.component[m.id] = m;
        if (m.isGlobal == 0 && m.isMain == 0) {
          isNull = false;
        }
        if ((m.type === "FOOTER" || m.type === "SIDEBAR") && i === 0) {
          i = j;
        }
      });
    });
  } else {
    cr.each(o, (d) => {
      cr.each(d, (m, j) => {
        if (!setting.component[m.id]) {
          setting.component[m.id] = m;
          setting.createComponent = m;
          if (m.isGlobal == 0 && m.isMain == 0) {
            isNull = false;
          }
          if ((m.type === "FOOTER" || m.type === "SIDEBAR") && i === 0) {
            i = j;
          }
        }
      });
    });
  }
  console.log(isNull, settings);
  if (
    [2, 3, 4, 6, 7].indexOf(parseInt(settings.pageInfo?.type, 10)) !== -1 &&
    isNull &&
    settings.isDesign
  ) {
    for (const a in o) {
      if (i === 0) {
        i = o[a].length;
      }
      o[a].splice(i, 0, {
        type: "NULL",
        category: settings.category,
        historyContent: { isDesign: settings.isDesign },
      });
      break;
    }
  }
});
